import { render, staticRenderFns } from "./AudienceSettings.vue?vue&type=template&id=4ff39e7e&lang=pug&"
import script from "./AudienceSettings.vue?vue&type=script&lang=js&"
export * from "./AudienceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports